import { useEffect } from "react";
import QRCode from "react-qr-code";
import { environment } from "../../common/env";

export const DownloadAppLinks = () => {
  useEffect(() => {
    openApp();
  }, []);

  const openApp = () => {
    const os = getMobileOS();
    if (os === "android") {
      if (environment.Android_App_Url) {
        window.location.href = environment.Android_App_Url;
      }
    } else if (os === "ios") {
      if (environment.IOS_App_Url) {
        window.location.href = environment.IOS_App_Url;
      }
    }
  };

  function getMobileOS() {
    const userAgent =
      typeof navigator !== "undefined"
        ? navigator.userAgent || (window as any).opera
        : "";
    if (/android/i.test(userAgent)) {
      return "android";
    }
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      return "ios";
    }
    return "other";
  }

  return (
    <main className="container mx-auto px-4 py-8 mb-auto relative">
      <div
        className="flex flex-col items-center space-y-6"
        style={{ paddingTop: "100px" }}
      >
        <h2 className="text-xl font-bold">Get the FoundAt App</h2>
        <div className="flex space-x-8">
          <div className="flex flex-col items-center">
            <QRCode value={environment.IOS_App_Url ? environment.IOS_App_Url : ''} size={128} />
            <a
              href={environment.IOS_App_Url}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 text-blue-600 underline"
            >
              Download on iOS
            </a>
          </div>
          <div className="flex flex-col items-center">
            <QRCode value={environment.Android_App_Url ? environment.Android_App_Url : ''} size={128} />
            <a
              href={environment.Android_App_Url}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 text-blue-600 underline"
            >
              Download on Android
            </a>
          </div>
        </div>
      </div>
    </main>
  );
};
